(function() {
  'use strict';
  
  // ユニークな名前空間
  window.HRASystem = window.HRASystem || {};
  
  // データ定義
  const HRA_DATA = {
    questions: [
      {
        id: 1,
        type: 'dual-dropdown',
        text: '年齢／性別',
        dropdowns: [
            {
            name: 'gender',
            label: '性別',
            options: [
              { value: 'f', label: '女性' },
              { value: 'm', label: '男性' }
            ]
          },
          {
            name: 'age',
            label: '年齢',
            options: [
              { value: '25', label: '〜２５歳' },
              { value: '26_35', label: '２６〜３５歳' },
              { value: '36_45', label: '３６〜４５歳' },
              { value: '46_55', label: '４６〜５５歳' },
              { value: '56', label: '５６歳〜' }
            ]
          }
        ],
        scores: {
          f_25: { oxidation: 0, glycation: 0, inflammation: 1 },
          f_26_35: { oxidation: 1, glycation: 1, inflammation: 2 },
          f_36_45: { oxidation: 2, glycation: 2, inflammation: 3 },
          f_46_55: { oxidation: 4, glycation: 4, inflammation: 4 },
          f_56: { oxidation: 5, glycation: 5, inflammation: 5 },
          m_25: { oxidation: 1, glycation: 1, inflammation: 0 },
          m_26_35: { oxidation: 2, glycation: 2, inflammation: 1 },
          m_36_45: { oxidation: 3, glycation: 3, inflammation: 2 },
          m_46_55: { oxidation: 3, glycation: 3, inflammation: 3 },
          m_56: { oxidation: 4, glycation: 4, inflammation: 4 }
        }
      },
      {
        id: 2,
        type: 'radio',
        text: '睡眠について',
        options: [
          { value: 'chronic_lack', label: '慢性的に睡眠不足', scores: { oxidation: 2, glycation: 2, inflammation: 2 } },
          { value: 'sometimes_lack', label: '時々睡眠不足', scores: { oxidation: 1, glycation: 1, inflammation: 1 } },
          { value: 'no_lack', label: '睡眠不足はない', scores: { oxidation: 0, glycation: 0, inflammation: 0 } }
        ]
      },
      {
        id: 3,
        type: 'radio',
        text: '運動について',
        options: [
          { value: 'no_exercise', label: '運動する習慣がない', scores: { oxidation: 2, glycation: 2, inflammation: 2 } },
          { value: 'weekly_1_2', label: '週１、２回運動する', scores: { oxidation: 1, glycation: 1, inflammation: 1 } },
          { value: 'weekly_3_plus', label: '週３回以上運動する', scores: { oxidation: 0, glycation: 0, inflammation: 0 } }
        ]
      },
      {
        id: 4,
        type: 'radio',
        text: 'ストレスについて',
        options: [
          { value: 'chronic', label: '慢性的に感じる', scores: { oxidation: 2, glycation: 2, inflammation: 2 } },
          { value: 'sometimes', label: '時々感じる', scores: { oxidation: 1, glycation: 1, inflammation: 1 } },
          { value: 'rarely', label: 'ほとんど感じない', scores: { oxidation: 0, glycation: 0, inflammation: 0 } }
        ]
      },
      {
        id: 5,
        type: 'radio',
        text: '日焼け止めや屋外で過ごす時間について',
        options: [
          { value: 'no_sunscreen_outdoor', label: '日焼け止めはほとんど塗らない<br class="sp">／屋外で過ごすことが多い', scores: { oxidation: 2, glycation: 2, inflammation: 2 } },
          { value: 'sunscreen_indoor', label: '日焼け止めを毎日塗る<br class="sp">／屋内で過ごすことが多い', scores: { oxidation: 0, glycation: 0, inflammation: 0 } }
        ]
      },
      {
        id: 6,
        type: 'radio',
        text: '家族に生活習慣病（糖尿病や脂質異常）の方が',
        options: [
          { value: 'yes', label: 'いる', scores: { oxidation: 2, glycation: 2, inflammation: 2 } },
          { value: 'no', label: 'いない', scores: { oxidation: 0, glycation: 0, inflammation: 0 } }
        ]
      },
      {
        id: 7,
        type: 'radio',
        text: '加工食品・コンビニ食・外食の頻度は',
        options: [
          { value: 'often_4plus', label: '週４回以上', scores: { oxidation: 2, glycation: 2, inflammation: 2 } },
          { value: 'sometimes_2_3', label: '週２〜３回程度', scores: { oxidation: 1, glycation: 1, inflammation: 1 } },
          { value: 'rarely', label: 'ほとんどない', scores: { oxidation: 0, glycation: 0, inflammation: 0 } }
        ]
      },
      {
        id: 8,
        type: 'radio',
        text: '飲酒について',
        options: [
          { value: 'often_3plus', label: '週3回以上飲酒する', scores: { oxidation: 2, glycation: 2, inflammation: 2 } },
          { value: 'sometimes_1_2', label: '週１、２回程度飲酒する', scores: { oxidation: 1, glycation: 1, inflammation: 1 } },
          { value: 'rarely', label: 'ほとんど飲酒しない', scores: { oxidation: 0, glycation: 0, inflammation: 0 } }
        ]
      },
      {
        id: 9,
        type: 'radio',
        text: '喫煙／受動喫煙について',
        options: [
          { value: 'many', label: '機会が多い', scores: { oxidation: 2, glycation: 2, inflammation: 2 } },
          { value: 'none', label: '機会がほとんどない', scores: { oxidation: 0, glycation: 0, inflammation: 0 } }
        ]
      },
      {
        id: 10,
        type: 'radio',
        text: 'スイーツや甘いドリンクを',
        options: [
          { value: 'often', label: 'よく口にする', scores: { oxidation: 2, glycation: 2, inflammation: 2 } },
          { value: 'rarely', label: 'あまり口にしない', scores: { oxidation: 0, glycation: 0, inflammation: 0 } }
        ]
      },
      {
        id: 11,
        type: 'radio',
        text: '食事の際に野菜を',
        options: [
          { value: 'rarely', label: 'あまり摂らない', scores: { oxidation: 0, glycation: 2, inflammation: 0 } },
          { value: 'often', label: 'よく摂る', scores: { oxidation: 0, glycation: 0, inflammation: 0 } }
        ]
      },
      {
        id: 12,
        type: 'radio',
        text: '揚げ物を',
        options: [
          { value: 'often', label: '好んでよく摂る', scores: { oxidation: 2, glycation: 0, inflammation: 0 } },
          { value: 'rarely', label: 'あまり摂らない', scores: { oxidation: 0, glycation: 0, inflammation: 0 } }
        ]
      },
      {
        id: 13,
        type: 'radio',
        text: '食事のスピードが',
        options: [
          { value: 'fast', label: '早い', scores: { oxidation: 0, glycation: 1, inflammation: 0 } },
          { value: 'normal_slow', label: '一般的〜遅い', scores: { oxidation: 0, glycation: 0, inflammation: 0 } }
        ]
      },
      {
        id: 14,
        type: 'radio',
        text: '食事量は',
        options: [
          { value: 'overeating', label: '食べ過ぎてしまう', scores: { oxidation: 0, glycation: 1, inflammation: 0 } },
          { value: 'moderate', label: 'あまり食べ過ぎることはない', scores: { oxidation: 0, glycation: 0, inflammation: 0 } }
        ]
      },
      {
        id: 15,
        type: 'radio',
        text: '肌が赤くなりやすい、腫れ・むくみが出やすい／花粉症である',
        options: [
          { value: 'yes', label: '当てはまる', scores: { oxidation: 0, glycation: 0, inflammation: 1 } },
          { value: 'no', label: '当てはまらない', scores: { oxidation: 0, glycation: 0, inflammation: 0 } }
        ]
      },
      {
        id: 16,
        type: 'radio',
        text: '前より肌が黄ぐすんで来ている気がする',
        options: [
          { value: 'yes', label: '当てはまる', scores: { oxidation: 1, glycation: 1, inflammation: 0 } },
          { value: 'no', label: '当てはまらない', scores: { oxidation: 0, glycation: 0, inflammation: 0 } }
        ]
      },
      {
        id: 17,
        type: 'radio',
        text: '風邪や体調不良が長引きやすい',
        options: [
          { value: 'yes', label: '当てはまる', scores: { oxidation: 0, glycation: 0, inflammation: 1 } },
          { value: 'no', label: '当てはまらない', scores: { oxidation: 0, glycation: 0, inflammation: 0 } }
        ]
      },
      {
        id: 18,
        type: 'radio',
        text: '便秘・下痢・お腹の張りなど腸の不調を感じやすい',
        options: [
          { value: 'yes', label: '当てはまる', scores: { oxidation: 0, glycation: 0, inflammation: 1 } },
          { value: 'no', label: '当てはまらない', scores: { oxidation: 0, glycation: 0, inflammation: 0 } }
        ]
      }
    ],
    
    rankDefinitions: {
      oxidation: { max: 26, ranks: { A: [0, 6], B: [7, 12], C: [13, 19], D: [20, 26] } },
      glycation: { max: 28, ranks: { A: [0, 7], B: [8, 14], C: [15, 21], D: [22, 28] } },
      inflammation: { max: 24, ranks: { A: [0, 6], B: [7, 11], C: [12, 18], D: [19, 24] } }
    }
  };
  
  // メインクラス
  class HRAAssessment {
    constructor() {
      try {
        this.form = document.getElementById('hra-form');
        this.questionsContainer = document.getElementById('hra-questions-container');
        this.resultContainer = document.getElementById('hra-result');
        this.submitContainer = document.getElementById('hra-submit-container');
        
        // 必須要素のチェック
        if (!this.form || !this.questionsContainer || !this.resultContainer || !this.submitContainer) {
          throw new Error('必須のDOM要素が見つかりません');
        }
        
        this.responses = {};
        this.shownQuestions = 1; // 表示済みの質問数（初期値1）
        this.questionElements = [];
        this.progressBar = null;
        this.isTransitioning = false; // 遷移中フラグ
        
        this.init();
      } catch (error) {
        console.error('HRAAssessment初期化エラー:', error);
      }
    }
    
    init() {
      try {
        this.addProgressBar();
        this.renderQuestions();
        this.attachEventListeners();
        this.showQuestion(0);
      } catch (error) {
        console.error('初期化中にエラーが発生しました:', error);
      }
    }
    
    addProgressBar() {
      try {
        const progressBar = document.createElement('div');
        progressBar.className = 'hra-progress';
        progressBar.innerHTML = '<div class="hra-progress__bar" id="hra-progress-bar"></div>';
        
        const contentElement = document.querySelector('.hra-assessment__content');
        if (!contentElement) {
          throw new Error('コンテンツ要素が見つかりません');
        }
        
        contentElement.prepend(progressBar);
        this.progressBar = progressBar;
      } catch (error) {
        console.error('プログレスバーの追加に失敗しました:', error);
      }
    }
    
    renderQuestions() {
      try {
        HRA_DATA.questions.forEach((question, index) => {
          const questionEl = this.createQuestionElement(question, index);
          if (questionEl) {
            this.questionsContainer.appendChild(questionEl);
            this.questionElements.push(questionEl);
          }
        });
      } catch (error) {
        console.error('質問のレンダリングに失敗しました:', error);
      }
    }
    
    createQuestionElement(question, index) {
      try {
        const div = document.createElement('div');
        div.className = 'hra-question hra-question--hidden';
        div.id = `hra-question-${index}`;
        div.innerHTML = `
          <div class="hra-question__top">
            <span class="hra-question__number">Q${question.id}</span>
            <div class="hra-question__content">
              <div class="hra-question__header">
                <span class="hra-question__text">${question.text}</span>
              </div>
            </div>
          </div>
        `;
        
        const inputContainer = this.createInputElement(question);
        const contentDiv = div.querySelector('.hra-question__content');
        if (contentDiv && inputContainer) {
          contentDiv.appendChild(inputContainer);
        }
        
        return div;
      } catch (error) {
        console.error('質問要素の作成に失敗しました:', error);
        return null;
      }
    }
    
    createInputElement(question) {
      try {
        switch(question.type) {
          case 'dropdown':
            return this.createDropdown(question);
          case 'dual-dropdown':
            return this.createDualDropdown(question);
          case 'radio':
            return this.createRadioGroup(question);
          default:
            console.warn(`未対応の質問タイプ: ${question.type}`);
            return null;
        }
      } catch (error) {
        console.error('入力要素の作成に失敗しました:', error);
        return null;
      }
    }
    
    createDualDropdown(question) {
      const container = document.createElement('div');
      container.className = 'hra-dual-dropdown';
      container.style.display = 'flex';
      container.style.gap = '15px';
      container.style.alignItems = 'flex-end';
      
      question.dropdowns.forEach((dropdown, index) => {
        const dropdownColumn = document.createElement('div');
        dropdownColumn.style.flex = '1';
        
        const label = document.createElement('label');
        label.className = 'hra-dropdown__label';
        label.textContent = dropdown.label;
        label.style.display = 'block';
        label.style.marginBottom = '5px';
        label.style.fontSize = '14px';
        label.style.color = '#666';
        
        const selectWrapper = document.createElement('div');
        selectWrapper.className = 'hra-dropdown-wrapper';
        
        const select = document.createElement('select');
        select.className = 'hra-dropdown__select';
        select.name = `hra-q${question.id}-${dropdown.name}`;
        select.id = `hra-q${question.id}-${dropdown.name}`;
        select.style.width = '100%';
        
        // デフォルトオプション
        const defaultOption = document.createElement('option');
        defaultOption.value = '';
        defaultOption.textContent = '選択してください';
        select.appendChild(defaultOption);
        
        // 選択肢を追加
        dropdown.options.forEach(option => {
          const optionEl = document.createElement('option');
          optionEl.value = option.value;
          optionEl.textContent = option.label;
          select.appendChild(optionEl);
        });
        
        selectWrapper.appendChild(select);
        dropdownColumn.appendChild(label);
        dropdownColumn.appendChild(selectWrapper);
        container.appendChild(dropdownColumn);
      });
      
      // 両方のドロップダウンが選択されたときに自動で次へ
      const checkBothSelected = () => {
        try {
          const ageSelect = container.querySelector(`select[name="hra-q${question.id}-age"]`);
          const genderSelect = container.querySelector(`select[name="hra-q${question.id}-gender"]`);
          
          if (ageSelect && genderSelect && ageSelect.value && genderSelect.value) {
            // 選択された値を組み合わせてdata属性に保存
            const combinedValue = `${genderSelect.value}_${ageSelect.value}`;
            container.dataset.combinedValue = combinedValue;
            
            // 自動で次の質問へ（質問インデックスを渡す）
            const questionIndex = parseInt(question.id) - 1;
            setTimeout(() => this.autoNextQuestion(questionIndex), 300);
          }
        } catch (error) {
          console.error('ドロップダウン選択チェックでエラー:', error);
        }
      };
      
      // 各ドロップダウンに変更イベントを追加
      container.querySelectorAll('select').forEach(select => {
        select.addEventListener('change', checkBothSelected.bind(this));
      });
      
      return container;
    }
    
    createDropdown(question) {
      const container = document.createElement('div');
      container.className = 'hra-dropdown-wrapper';
      
      const select = document.createElement('select');
      select.className = 'hra-dropdown__select';
      select.name = `hra-q${question.id}`;
      select.id = `hra-q${question.id}`;
      
      // 変更時に自動で次へ（質問インデックスを渡す）
      select.addEventListener('change', () => {
        if (select.value) {
          const questionIndex = parseInt(question.id) - 1;
          setTimeout(() => this.autoNextQuestion(questionIndex), 300);
        }
      });
      
      // デフォルトオプション
      const defaultOption = document.createElement('option');
      defaultOption.value = '';
      defaultOption.textContent = '選択してください';
      select.appendChild(defaultOption);
      
      // 選択肢を追加
      question.options.forEach(option => {
        const optionEl = document.createElement('option');
        optionEl.value = option.value;
        optionEl.textContent = option.label;
        optionEl.dataset.scores = JSON.stringify(option.scores);
        select.appendChild(optionEl);
      });
      
      container.appendChild(select);
      return container;
    }
    
    createRadioGroup(question) {
      const container = document.createElement('div');
      container.className = 'hra-radio-group';
      
      question.options.forEach((option, index) => {
        const itemDiv = document.createElement('div');
        itemDiv.className = 'hra-radio-group__item';
        
        const input = document.createElement('input');
        input.type = 'radio';
        input.name = `hra-q${question.id}`;
        input.id = `hra-q${question.id}-${index}`;
        input.value = option.value;
        input.className = 'hra-radio-group__input';
        input.dataset.scores = JSON.stringify(option.scores);
        
        // 変更時に自動で次へ（質問インデックスを渡す）
        input.addEventListener('change', () => {
          const questionIndex = parseInt(question.id) - 1;
          setTimeout(() => this.autoNextQuestion(questionIndex), 300);
        });
        
        const label = document.createElement('label');
        label.htmlFor = input.id;
        label.className = 'hra-radio-group__label';
        label.innerHTML = option.label;
        
        itemDiv.appendChild(input);
        itemDiv.appendChild(label);
        container.appendChild(itemDiv);
      });
      
      return container;
    }
    
    showQuestion(index) {
      try {
        // 全ての質問を表示（ただし未来の質問は非表示）
        this.questionElements.forEach((el, i) => {
          if (i <= index) {
            el.classList.remove('hra-question--hidden', 'hra-question--inactive');
          } else {
            el.classList.add('hra-question--hidden');
          }
        });
        
        // 現在の質問にスクロール
        if (index < this.questionElements.length) {
          setTimeout(() => {
            this.questionElements[index].scrollIntoView({ behavior: 'smooth', block: 'center' });
          }, 100);
        }
        
        // プログレスバーを更新
        this.updateProgressBar(index);
      } catch (error) {
        console.error('質問表示でエラー:', error);
      }
    }
    
    updateProgressBar(index) {
      try {
        const progressBar = document.getElementById('hra-progress-bar');
        if (progressBar) {
          const progress = ((index + 1) / (HRA_DATA.questions.length + 1)) * 100;
          progressBar.style.width = `${progress}%`;
        }
      } catch (error) {
        console.error('プログレスバー更新でエラー:', error);
      }
    }
    
    autoNextQuestion(fromQuestionIndex) {
      // 表示済みの最後の質問（shownQuestions - 1）以外からの呼び出しは無視
      if (fromQuestionIndex !== (this.shownQuestions - 1)) {
        return;
      }
      
      // 遷移中の場合は何もしない
      if (this.isTransitioning) return;
      
      try {
        this.isTransitioning = true;
        
        if (this.shownQuestions < HRA_DATA.questions.length) {
          this.showQuestion(this.shownQuestions);
          this.shownQuestions++; // 表示済み質問数をカウントアップ
        } else {
          // 最後の質問の後は送信ボタンを表示
          this.submitContainer.classList.remove('hra-question--hidden');
          this.submitContainer.scrollIntoView({ behavior: 'smooth', block: 'center' });
          
          // プログレスバーを100%に
          this.updateProgressBar(HRA_DATA.questions.length);
        }
        
        // 遷移完了後にフラグをリセット
        setTimeout(() => {
          this.isTransitioning = false;
        }, 500);
      } catch (error) {
        console.error('次の質問への遷移でエラー:', error);
        this.isTransitioning = false;
      }
    }
    
    attachEventListeners() {
      try {
        this.form.addEventListener('submit', (e) => {
          e.preventDefault();
          this.handleSubmit();
        });
      } catch (error) {
        console.error('イベントリスナーの設定でエラー:', error);
      }
    }
    
    handleSubmit() {
      try {
        const scores = this.calculateScores();
        const results = this.generateResults(scores);
        this.displayResults(results);
      } catch (error) {
        console.error('送信処理でエラー:', error);
        alert('結果の計算中にエラーが発生しました。ページを再読み込みしてください。');
      }
    }
    
    calculateScores() {
      const scores = { oxidation: 0, glycation: 0, inflammation: 0 };
      
      try {
        // 各質問の回答を集計
        HRA_DATA.questions.forEach(question => {
          if (question.type === 'dual-dropdown') {
            const container = this.form.querySelector('.hra-dual-dropdown');
            if (container && container.dataset.combinedValue) {
              const combinedValue = container.dataset.combinedValue;
              if (question.scores[combinedValue]) {
                const optionScores = question.scores[combinedValue];
                scores.oxidation += optionScores.oxidation || 0;
                scores.glycation += optionScores.glycation || 0;
                scores.inflammation += optionScores.inflammation || 0;
              }
            }
          } else if (question.type === 'dropdown') {
            const select = this.form.querySelector(`select[name="hra-q${question.id}"]`);
            if (select && select.selectedIndex > 0) {
              const selectedOption = select.options[select.selectedIndex];
              if (selectedOption && selectedOption.dataset.scores) {
                const optionScores = JSON.parse(selectedOption.dataset.scores);
                scores.oxidation += optionScores.oxidation || 0;
                scores.glycation += optionScores.glycation || 0;
                scores.inflammation += optionScores.inflammation || 0;
              }
            }
          } else if (question.type === 'radio') {
            const selected = this.form.querySelector(`input[name="hra-q${question.id}"]:checked`);
            if (selected && selected.dataset.scores) {
              const optionScores = JSON.parse(selected.dataset.scores);
              scores.oxidation += optionScores.oxidation || 0;
              scores.glycation += optionScores.glycation || 0;
              scores.inflammation += optionScores.inflammation || 0;
            }
          }
        });
      } catch (error) {
        console.error('スコア計算でエラー:', error);
      }
      
      return scores;
    }
    
    generateResults(scores) {
      try {
        // ランク判定
        const ranks = {
          oxidation: this.getRank(scores.oxidation, HRA_DATA.rankDefinitions.oxidation.ranks),
          glycation: this.getRank(scores.glycation, HRA_DATA.rankDefinitions.glycation.ranks),
          inflammation: this.getRank(scores.inflammation, HRA_DATA.rankDefinitions.inflammation.ranks)
        };
        
        // 合計スコアから100点満点に換算
        const totalPoints = scores.oxidation + scores.glycation + scores.inflammation;
        const totalScore = this.convertToScore(totalPoints);
        
        return { scores, ranks, totalScore, totalPoints };
      } catch (error) {
        console.error('結果生成でエラー:', error);
        return null;
      }
    }
    
    getRank(score, rankDef) {
      if (score <= rankDef.A[1]) return 'A';
      if (score <= rankDef.B[1]) return 'B';
      if (score <= rankDef.C[1]) return 'C';
      return 'D';
    }
    
    convertToScore(points) {
      const conversions = [
        { range: [0, 2], score: 100 },
        { range: [3, 5], score: 95 },
        { range: [6, 9], score: 90 },
        { range: [10, 14], score: 85 },
        { range: [15, 19], score: 80 },
        { range: [20, 23], score: 75 },
        { range: [24, 28], score: 70 },
        { range: [29, 31], score: 65 },
        { range: [32, 34], score: 60 },
        { range: [35, 37], score: 55 },
        { range: [38, 40], score: 50 },
        { range: [41, 44], score: 45 },
        { range: [45, 49], score: 40 },
        { range: [50, 54], score: 35 },
        { range: [55, 59], score: 30 },
        { range: [60, 64], score: 25 },
        { range: [65, 69], score: 20 },
        { range: [70, 72], score: 15 },
        { range: [73, 78], score: 10 }
      ];
      
      const conversion = conversions.find(c => points >= c.range[0] && points <= c.range[1]);
      return conversion ? conversion.score : 0;
    }
    
    displayResults(results) {
      if (!results) {
        alert('結果の表示中にエラーが発生しました。');
        return;
      }
      
      try {
        // プログレスバーを非表示にする
        if (this.progressBar) {
          this.progressBar.style.display = 'none';
        }
        
        // タイトルを非表示にする
        const assessmentTitle = document.querySelector('.hra-assessment__title');
        if (assessmentTitle) {
          assessmentTitle.style.display = 'none';
        }
        
        // 結果をデータ属性として設定
        this.resultContainer.dataset.totalScore = results.totalScore;
        this.resultContainer.dataset.oxidationRank = results.ranks.oxidation;
        this.resultContainer.dataset.glycationRank = results.ranks.glycation;
        this.resultContainer.dataset.inflammationRank = results.ranks.inflammation;
        
        // displayResultsメソッド内のinnerHTML部分を以下に置き換えてください：

        this.resultContainer.innerHTML = `
          <div class="hra-result__header">
            <div class="hra-result__subtitle">あなたの</div>
            <h3 class="hra-result__title">"連鎖エイジング"抵抗力は</h3>
          </div>

          <div class="hra-result__score">
            <div class="hra-result__score-box">
              <span class="hra-result__score-number">${results.totalScore}</span><span class="hra-result__score-label">点/100点</span>
            </div>
          </div>

          <div class="hra-result__chart-container">
            <div class="hra-result__chart-wrapper">
              <canvas id="hra-risk-chart" class="hra-result__chart-canvas"></canvas>
            </div>
          </div>
          
          <div class="hra-result__feedback">
            <div class="hra-result__disclaimer">
              <div style="text-align:left;">
                ${this.getTotalComment(results.totalScore)}
                <br><br>
                日頃からアンチエイジングに重要な生活習慣をキープし、さらに上を目指していきましょう。
                <br>
                インナーケアやスキンケアでも抗酸化・抗糖化・抗炎症をしてくれるアイテムを使うことで高みを目指しましょう！
              </div>
            </div>
            
            <div class="hra-result__feedback-item">
              <h4 class="hra-result__feedback-title">酸化リスク</h4>
              <p class="hra-result__feedback-text">${this.getFeedbackText('oxidation', results.ranks.oxidation)}</p>
            </div>
            
            <div class="hra-result__feedback-item">
              <h4 class="hra-result__feedback-title">糖化リスク</h4>
              <p class="hra-result__feedback-text">${this.getFeedbackText('glycation', results.ranks.glycation)}</p>
            </div>
            
            <div class="hra-result__feedback-item">
              <h4 class="hra-result__feedback-title">炎症リスク</h4>
              <p class="hra-result__feedback-text">${this.getFeedbackText('inflammation', results.ranks.inflammation)}</p>
            </div>
          </div>
          
          <!-- SNSシェアセクション -->
          <div class="hra-share">
            <div class="hra-share__buttons">
              <a href="javascript:void(0);" class="hra-share__button hra-share__button--x" data-share="x">
                <img src="https://cdn.shopify.com/s/files/1/0527/6060/8917/files/x_e665facf-2229-4e8d-9815-87fe6a27916d.png?v=1753263879" alt="X" class="hra-share__icon">
                <span>ポストする</span>
              </a>
              <a href="javascript:void(0);" class="hra-share__button hra-share__button--facebook" data-share="facebook">
                <img src="https://cdn.shopify.com/s/files/1/0527/6060/8917/files/Facebook.png?v=1753263879" alt="Facebook" class="hra-share__icon">
                <span>シェアする</span>
              </a>
              <a href="javascript:void(0);" class="hra-share__button hra-share__button--line" data-share="line">
                <img src="https://cdn.shopify.com/s/files/1/0527/6060/8917/files/line.png?v=1753263879" alt="LINE" class="hra-share__icon">
                <span>LINEで送る</span>
              </a>
            </div>
          </div>
          
          <!-- 連鎖エイジング説明セクション -->
          <div class="hra-aging-info">
            <h3 class="hra-aging-info__title">
              「エイジングは連鎖し悪化する<br>
              酸化 × 糖化 × 炎症の関係とは」
            </h3>
            <p class="hra-aging-info__subtitle">コラムを読む</p>
            <a href="https://fatuite.com/pages/aging-chain-reaction" class="hra-aging-info__button">
              <span class="hra-aging-info__arrow">▶</span>
            </a>
          </div>
          
          <!-- 肌画像比較セクション -->
          <div class="hra-skin-comparison">
            <a href="https://fatuite.com/pages/aging-chain-reaction" class="hra-skin-comparison__item">
              <img src="https://cdn.shopify.com/s/files/1/0527/6060/8917/files/Frame_396.png?v=1753264483" alt="連鎖エイジングの比較画像" class="hra-skin-comparison__image">
            </a>
          </div>
        `;
        
        // フォームを非表示にして結果を表示
        this.form.style.display = 'none';
        this.resultContainer.classList.remove('hra-result--hidden');
        
        // Chart.jsでレーダーチャートを描画
        this.createRadarChart(results);
        
        // ページの一番上までスクロール
        window.scrollTo({ top: 0, behavior: 'smooth' });
      } catch (error) {
        console.error('結果表示でエラー:', error);
      }

      // displayResultsメソッドの最後（window.scrollToの後）に以下を追加：

      // SNSシェアボタンのイベントリスナーを設定
      setTimeout(() => {
        const shareButtons = this.resultContainer.querySelectorAll('[data-share]');
        shareButtons.forEach(button => {
          button.addEventListener('click', (e) => {
            e.preventDefault();
            const shareType = button.dataset.share;
            const scoreElement = document.querySelector('[data-total-score]');
            const score = scoreElement ? scoreElement.dataset.totalScore : '0';
            const url = window.location.href;
            
            if (shareType === 'x') {
              const text = '私の"連鎖エイジング"抵抗力は' + score + '点でした！\n\n#連鎖エイジング #アンチエイジング';
              window.open('https://twitter.com/intent/tweet?text=' + encodeURIComponent(text) + '&url=' + encodeURIComponent(url), '_blank');
            } else if (shareType === 'facebook') {
              window.open('https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(url), '_blank');
            } else if (shareType === 'line') {
              // ユーザーエージェントでPCかモバイルか判定
              const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
              const text = '私の"連鎖エイジング"抵抗力は' + score + '点でした！';
                // モバイルの場合：旧URLを使用（テキストが正しく表示される）
                const lineUrl = 'https://line.me/R/msg/text/?' + encodeURIComponent(text + '\n' + url);
                window.open(lineUrl, '_blank');
            }
          });
        });
      }, 100);
      
    }
    
    createRadarChart(results) {
      try {
        // ランクベースでチャートを作成
        const chartContainer = document.getElementById('hra-risk-chart');
        if (chartContainer && chartContainer.parentElement) {
          chartContainer.parentElement.innerHTML = this.createSVGChart(results.ranks);
        }
      } catch (error) {
        console.error('チャート作成でエラー:', error);
      }
    }
    
    createSVGChart(ranks) {
      // チャートの中心と最大半径
      const cx = 175;
      const cy = 175;
      const maxRadius = 120;
      
      // 正三角形の頂点への角度（度）
      const angles = [
        -90,  // 上（酸化）
        30,  // 右下（糖化）
        150    // 左下（炎症）
      ];
      
      // 角度をラジアンに変換する関数
      const toRad = (deg) => deg * Math.PI / 180;
      
      // ランクに応じた半径の割合（A:100%, B:75%, C:50%, D:25%）
      const rankToRadius = {
        'A': 1.0,   // 100%
        'B': 0.75,  // 75%
        'C': 0.5,   // 50%
        'D': 0.25   // 25%
      };
      
      // グリッドラインの作成（25%, 50%, 75%, 100%）
      const gridLines = [25, 50, 75, 100].map(percent => {
        const r = maxRadius * percent / 100;
        const points = angles.map(angle => ({
          x: cx + r * Math.cos(toRad(angle)),
          y: cy + r * Math.sin(toRad(angle))
        }));
        return `M${points[0].x},${points[0].y} L${points[1].x},${points[1].y} L${points[2].x},${points[2].y} Z`;
      });
      
      // ランクに応じた三角形の頂点を計算
      const scorePoints = [
        { // 酸化（上）
          x: cx + (maxRadius * rankToRadius[ranks.oxidation]) * Math.cos(toRad(angles[0])),
          y: cy + (maxRadius * rankToRadius[ranks.oxidation]) * Math.sin(toRad(angles[0]))
        },
        { // 糖化（左下）
          x: cx + (maxRadius * rankToRadius[ranks.glycation]) * Math.cos(toRad(angles[1])),
          y: cy + (maxRadius * rankToRadius[ranks.glycation]) * Math.sin(toRad(angles[1]))
        },
        { // 炎症（右下）
          x: cx + (maxRadius * rankToRadius[ranks.inflammation]) * Math.cos(toRad(angles[2])),
          y: cy + (maxRadius * rankToRadius[ranks.inflammation]) * Math.sin(toRad(angles[2]))
        }
      ];
      
      const scorePath = `M${scorePoints[0].x},${scorePoints[0].y} L${scorePoints[1].x},${scorePoints[1].y} L${scorePoints[2].x},${scorePoints[2].y} Z`;
      
      return `
        <div class="hra-chart-container">
          <svg viewBox="0 0 350 350" class="hra-chart-svg">
            <!-- グリッドライン -->
            ${gridLines.map((path, i) => `
              <path d="${path}" fill="none" stroke="#B2B2B2" stroke-width="${i === 3 ? '1' : '0.5'}" opacity="1" />
            `).join('')}
            
            <!-- 中心から各頂点への線 -->
            ${angles.map(angle => {
              const x2 = cx + maxRadius * Math.cos(toRad(angle));
              const y2 = cy + maxRadius * Math.sin(toRad(angle));
              return `<line x1="${cx}" y1="${cy}" x2="${x2}" y2="${y2}" stroke="#B2B2B2" stroke-width="0.5" opacity="1" />`;
            }).join('')}
            
            <!-- スコアに応じた三角形 -->
            <path d="${scorePath}" fill="#8b7355" opacity="1" />
            
           
          </svg>
          
          <!-- HTMLラベル -->
          <div class="hra-chart-label hra-chart-label--oxidation">
            <span class="hra-chart-label__title">酸化リスク<br></span>
            <span class="hra-chart-label__rank">${ranks.oxidation}</span>
          </div>
          <div class="hra-chart-label hra-chart-label--glycation">
            <span class="hra-chart-label__title">糖化リスク<br></span>
            <span class="hra-chart-label__rank">${ranks.glycation}</span>
          </div>
          <div class="hra-chart-label hra-chart-label--inflammation">
            <span class="hra-chart-label__title">炎症リスク<br></span>
            <span class="hra-chart-label__rank">${ranks.inflammation}</span>
          </div>
        </div>
      `;
    }
     // <!-- 目盛りラベル -->
     //        <text x="${cx + maxRadius + 10}" y="${cy + 5}" fill="#B2B2B2" font-size="10" text-anchor="start">100</text>
     //        <text x="${cx + maxRadius * 0.75 + 8}" y="${cy + 5}" fill="#B2B2B2" font-size="10" text-anchor="start">75</text>
     //        <text x="${cx + maxRadius * 0.5 + 8}" y="${cy + 5}" fill="#B2B2B2" font-size="10" text-anchor="start">50</text>
     //        <text x="${cx + maxRadius * 0.25 + 8}" y="${cy + 5}" fill="#B2B2B2" font-size="10" text-anchor="start">25</text>
    
    getFeedbackText(type, rank) {
      const feedback = {
        oxidation: {
          A: '酸化リスク「Aランク」のあなたは、活性酸素の影響が少なく、健やかな状態です。',
          B: '酸化リスク「Bランク」のあなたは、軽い酸化傾向あり。睡眠と食事で整えて。',
          C: '酸化リスク「Cランク」のあなたは、酸化ストレスが高まりやすい状態です。要注意！',
          D: '酸化リスク「Dランク」のあなたは、酸化ダメージが蓄積している可能性が！抗酸化ケアを強化して。'
        },
        glycation: {
          A: '糖化リスク「Aランク」のあなたは、糖代謝がスムーズで、糖化リスクは低めです。',
          B: '糖化リスク「Bランク」のあなたは、軽い糖化の傾向あり。甘い物は控えめに。',
          C: '糖化リスク「Cランク」のあなたは、食習慣の影響で糖化が進みやすくなっています。食事の見直しを！',
          D: '糖化リスク「Dランク」のあなたは、高血糖傾向あり。食事と血糖コントロールを意識して！'
        },
        inflammation: {
          A: '炎症リスク「Aランク」のあなたは、炎症反応は抑えられており、安定した状態です。',
          B: '炎症リスク「Bランク」のあなたは、わずかに炎症傾向。腸内環境の見直しが効果的。',
          C: '炎症リスク「Cランク」のあなたは、慢性炎症の兆しあり。生活習慣を整えて。',
          D: '炎症リスク「Dランク」のあなたは、慢性的に炎症が続いている可能性大。早めの対策を。'
        }
      };
      
      return feedback[type][rank] || '';
    }
    
    getTotalComment(score) {
      // より詳細な判定のため、個別のランクも確認
      const results = this.generateResults(this.calculateScores());
      const ranks = results.ranks;
      
      // 全てAランクの場合（コメント①）
      if (ranks.oxidation === 'A' && ranks.glycation === 'A' && ranks.inflammation === 'A') {
        return '現在のあなたは、酸化・糖化・炎症のいずれも安定しており、体内環境はとても整った状態です。<br><br>' +
               'ただし、年齢とともに見えない変化がゆっくりと始まることもあるため、油断は禁物です。<br><br>' +
               '睡眠不足や甘いものの摂りすぎ、ストレスの蓄積には特にご注意ください。<br>' +
               'バランスの良い食事や、軽い運動を取り入れて今の状態をキープしていきましょう。<br><br>' +
               'また、今後に備えて、抗酸化・抗糖化・抗炎症に着目したインナーケアやスキンケアを"お守り"として取り入れておくのもおすすめです。';
      }
      
      // 全てBランクの場合（コメント②）
      else if (ranks.oxidation === 'B' && ranks.glycation === 'B' && ranks.inflammation === 'B') {
        return '今のあなたは、ほぼ安定した状態にありながらも、体内で「連鎖エイジング」が始まりかけている兆しが見られます。<br><br>' +
               '特に、睡眠の乱れや糖質・脂質の摂りすぎ、ストレスの蓄積が複数のリスクに影響しやすくなります。<br><br>' +
               'まずは、就寝時間を整えることや、甘いもの・ジャンクフードの頻度を減らすことから始めてみましょう。<br>' +
               '深呼吸や軽いストレッチも自律神経の安定に効果的です。<br><br>' +
               'こうした生活習慣の見直しと併せて、抗酸化・抗糖化・抗炎症ケアをサポートできるインナーケアを取り入れることで、より良い状態を維持しやすくなります。';
      }
      
      // 全てCランクの場合（コメント③）
      else if (ranks.oxidation === 'C' && ranks.glycation === 'C' && ranks.inflammation === 'C') {
        return '現在のあなたは、酸化・糖化・炎症のいずれか、または複数の項目において体内バランスが乱れ始めている可能性があります。<br><br>' +
               '「連鎖エイジング」がゆるやかに進行しはじめ、肌や体調の変化として感じられる方もいらっしゃるかもしれません。<br><br>' +
               'まずは、生活リズムを整え、食事・睡眠・ストレスの3つの柱を見直していきましょう。<br>' +
               '夜更かしを避ける、野菜を増やす、毎日湯船につかるといった習慣がサポートになります。<br><br>' +
               '内側からバランスを整えるサポートとして、抗酸化・抗糖化・抗炎症に着目したサプリメントやスキンケアを活用するのも効果的です。';
      }
      
      // 全てDランクの場合（コメント④）
      else if (ranks.oxidation === 'D' && ranks.glycation === 'D' && ranks.inflammation === 'D') {
        return '酸化・糖化・炎症の数値において、全体的に体内ダメージの蓄積が進んでいる可能性があります。<br><br>' +
               'この状態が続くと、肌や体調にさまざまな影響が現れやすくなるため、早めの対策が大切です。<br><br>' +
               'まずは、できることから生活習慣を整えていきましょう。<br>' +
               '夜は1時間早く寝る、揚げ物や甘いものを週1回減らす、深呼吸や散歩を日常に取り入れるなど、無理のない範囲で始めてみてください。<br><br>' +
               '加えて、体内のバランスをケアする抗酸化・抗糖化・抗炎症サポート成分を、インナーケアとして取り入れることもご検討ください。';
      }
      
      // 評価が分かれているケース（コメント⑤）
      else {
        return 'あなたの結果は、酸化・糖化・炎症それぞれのリスクが分かれており、体内のバランスがやや不安定な状態かもしれません。<br><br>' +
               '睡眠不足や過労、偏った食事など、複数の要因が関係している可能性があります。<br><br>' +
               'まずは、朝昼晩の食事のリズムを整え、1日1回は体をほぐす時間を持つようにしてみてください。<br>' +
               'また、白湯を飲む・夜にスマホを控えるといった小さな積み重ねも効果的です。<br><br>' +
               'その上で、不調の原因がどこにあるのかを意識しながら、必要に応じてインナーケアを取り入れ、未来のコンディション維持に役立てていきましょう。';
      }
    }
  }
  
  // DOMContentLoadedイベントで初期化
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      // hra-assessmentクラスが存在する場合のみ初期化
      if (document.querySelector('.hra-assessment')) {
        try {
          window.HRASystem.instance = new HRAAssessment();
        } catch (error) {
          console.error('HRAシステムの初期化に失敗しました:', error);
        }
      }
    });
  } else {
    // 既に読み込み済みの場合
    if (document.querySelector('.hra-assessment')) {
      try {
        window.HRASystem.instance = new HRAAssessment();
      } catch (error) {
        console.error('HRAシステムの初期化に失敗しました:', error);
      }
    }
  }
})();